import React from "react";
import { observer } from "mobx-react";

import { withStyles } from "@material-ui/core/styles";

import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";

import RoomCardHeader from "./RoomCardHeader";

class RoomComparisonCardHeader extends React.Component {
    render() {
        const classes = this.props.classes;

        return (
            <Box className={classes.Container}>
                <Box className={classes.Left}>
                    <Typography
                        className={classes.Priority}
                        style={{
                            width: "min-content",
                        }}
                    >
                        {(this.props.variety || {}).human_name || "All"} Rooms
                    </Typography>
                </Box>
            </Box>
        );
    }
}

// Pull in styles from RoomCardHeader
export default withStyles(RoomCardHeader.styles)(observer(RoomComparisonCardHeader));